export default __webpack_public_path__ + "static/media/L2KQa-dqcl8.b55dd3ae.jpg";